import axios from 'axios';
import {modal} from '../modal-template/modal-template';
import {filter} from "../filter/filter";

const DATA_ATTR = 'data-account-cabinet-students-progress';
const CLASS_PREFIX = 'account-cabinet-students-progress';
const STORAGE_KEY_PREFIX = `${DATA_ATTR}-filters`; // will store per-type under `${STORAGE_KEY_PREFIX}-${type}`

export function initPersonalAccountStudentsProgress($container) {
    const $templateMain = document.querySelector(`[${DATA_ATTR}-template-main]`);
    const $templateTableCase = document.querySelector(`[${DATA_ATTR}-template-table-case]`);
    const $templateTableTroika = document.querySelector(`[${DATA_ATTR}-template-table-troika]`);
    const $templateTableRowCase = document.querySelector(`[${DATA_ATTR}-template-table-case-row]`);
    const $templateFilterSearch = document.querySelector(`[${DATA_ATTR}-template-filter-search]`);


    let $componentContainer = null;
    let $contentContainer = null;
    let $filtersContainer = null;
    let $tableFragment = null;
    let $loader = null
    let $pagination = null;
    let $paginationContainer = null;
    let $paginationPrev = null;
    let $paginationNext = null;
    let $groupCountEl = null;
    let $studentCountEl = null;

    let currentSkip = 0;
    let currentTake = 10;
    let totalCount = 0;
    let currentType = 'case';

    // currentFilters: { [metaName]: [id1, id2, ...], ... }
    let currentFilters = {};

    init();

    async function init() {
        if (!$templateMain) return;
        await renderMain();
    }

    function renderMain() {
        const $mainFragment = $templateMain.content.cloneNode(true);
        const $switches = $mainFragment.querySelectorAll(`[${DATA_ATTR}-switch]`);
        $componentContainer = $mainFragment.querySelector(`[${DATA_ATTR}]`);
        $contentContainer = $componentContainer.querySelector(`[${DATA_ATTR}-content]`);
        $filtersContainer = $componentContainer.querySelector(`[${DATA_ATTR}-filters]`);
        $loader = $componentContainer.querySelector(`[${DATA_ATTR}-loader]`);
        $pagination = $componentContainer.querySelector(`[${DATA_ATTR}-pagination]`);
        $paginationContainer = $pagination ? $pagination.querySelector(`[${DATA_ATTR}-pagination-container]`) : null;
        $groupCountEl = $componentContainer.querySelector(`[${DATA_ATTR}-group-count]`);
        $studentCountEl = $componentContainer.querySelector(`[${DATA_ATTR}-student-count]`);

        // pagination prev / container / next are laid out as children in template:
        // [prev, container, next] — защитно выбираем по позиции
        if ($pagination) {
            const children = Array.from($pagination.children);
            $paginationPrev = children[0] || null;
            // children[1] is the container already in $paginationContainer
            $paginationNext = children[2] || null;
        }

        $switches.forEach($switch => {
            $switch.addEventListener('click', () => {
                // reset pagination when switching type
                currentType = $switch.dataset.type;
                currentSkip = 0;
                $switch.classList.add('active');
                $switches.forEach(currentSwitch => {
                    if (currentSwitch !== $switch) {
                        currentSwitch.classList.remove('active');
                    }
                })

                // load stored filters for this type and re-render filters + tasks
                loadFiltersFromStorage(currentType);
                fetchFilters(currentType);
                fetchTasks(currentType);

            })
        })

        $container.appendChild($mainFragment);

        // on initial render load stored filters for default type
        loadFiltersFromStorage(currentType);
        fetchFilters(currentType);
        fetchTasks(currentType);
        document.dispatchEvent(new CustomEvent('account-cabinet:render-complete', {bubbles: true}));
    }

    function fetchTasks(type) {
        $loader.style.display = 'flex';

        // include currentFilters as JSON string; backend should parse this (or adapt as needed)
        const params = {
            type: currentType,
            skip: currentSkip,
            take: currentTake,
            filters: JSON.stringify(currentFilters || {})
        };

        axios.get('/api/group-tasks/progress', {params})
            .then(response => {
                const {data, meta} = response.data;

                // try to extract total count from meta (support different keys)
                totalCount = extractTotalFromMeta(meta);

                // update header & info counts if elements exist
                if ($groupCountEl) {
                    const shown = Array.isArray(data) ? data.length : 0;
                    $groupCountEl.textContent = `${shown} / 100`;
                }
                if ($studentCountEl) {
                    $studentCountEl.textContent = `${totalCount} студента`;
                }

                renderTable(data, currentType);
                renderPagination(totalCount);

            }).catch(error => {
            console.error(error);
        }).finally(() => {
            $loader.style.display = 'none';
        });
    }

    async function fetchFilters(type) {
        try {
            const response = await axios.get('/api/group-tasks/filters', {
                params: {
                    type: currentType,
                }
            });

            // ожидаем, что сервер возвращает { data: [...] }
            const filtersData = response.data && response.data.data ? response.data.data : [];

            // ensure currentFilters contains stored filters for this type (loadFiltersFromStorage already ran on type switch/initial)
            await renderFilters(currentType, filtersData);
        } catch (error) {
            console.error('fetchFilters error:', error);
        } finally {
            // можно добавить индикатор загрузки здесь, если нужно
        }
    }

    function extractTotalFromMeta(meta) {
        if (!meta) return 0;
        // common possible keys: total, total_count, count, totalItems, totalItemsCount
        return meta.total ?? meta.total_count ?? meta.count ?? meta.totalItems ?? meta.totalItemsCount ?? 0;
    }

    async function renderFilters(type, filtersData = []) {
        console.log('renderFilters', type);
        console.log('filtersData', filtersData)

        $filtersContainer.innerHTML = '';

        // helper: безопасно получить display name для айтема
        const itemName = (item) => {
            if (!item) return 'ID unknown';
            return item.name || item.title || (item.first_name || item.last_name ? `${item.first_name || ''} ${item.last_name || ''}`.trim() : item.email) || `ID ${item.id ?? 'unknown'}`;
        };

        // Пройтись по полученным фильтрам и создать каждый list-фильтр
        filtersData.forEach(filterData => {
            console.log('filterData', filterData);
            // ожидаем структуру { entity: 'Группы учителя', meta: 'university_groups', items: [{id, name}, ...] }
            const entityTitle = filterData.entity || filterData.meta || 'Фильтр';
            const metaName = filterData.meta || filterData.entity || 'unknown_meta';
            const itemsRaw = Array.isArray(filterData.items) ? filterData.items : [];

            const items = itemsRaw.map(i => ({
                id: i.id,
                name: itemName(i),
            }));

            // get current saved value for this meta (array of ids) — default empty array = "все"
            const initialValue = Array.isArray(currentFilters[metaName]) ? currentFilters[metaName] : [];

            // Вызываем вашу функцию filter (сохранил прежние названия событий)
            filter($filtersContainer, {
                type: 'list',
                filterFor: metaName,                 // мета-имя таблицы/сущности
                title: `Все ${entityTitle}`,        // заголовок (можно изменить)
                name: entityTitle,                  // читаемое имя фильтра
                data: items.length ? items : [],    // массив айтемов {id, name}
                value: initialValue, // начальное значение (пустой = "все")
                onAccept: (val) => {
                    // val expected as array of selected ids — save and refresh list
                    console.log('Приняли фильтр:', metaName, val);
                    currentFilters[metaName] = Array.isArray(val) ? val : [];
                    saveFiltersToStorage(currentType);
                    // reset pagination to first page when filters applied
                    currentSkip = 0;
                    fetchTasks(currentType);
                },
                onClear: () => {
                    console.log('Сброс фильтра:', metaName);
                    // remove this filter from currentFilters (means "all")
                    delete currentFilters[metaName];
                    saveFiltersToStorage(currentType);
                    currentSkip = 0;
                    fetchTasks(currentType);
                },
                onChange: (val) => {
                    // live changes — keep currentFilters in sync but do not necessarily fetch on every change
                    console.log('Изменилось:', metaName, val);
                    currentFilters[metaName] = Array.isArray(val) ? val : [];
                    // keep saved state so UI reloads with the latest selections
                    saveFiltersToStorage(currentType);
                },
            });
        });

        // switch filter: берём значение из currentFilters если есть, иначе дефолт 0
        filter($filtersContainer, {
            type: 'switch',
            filterFor: 'is_completed',
            title: `Выполнили задание`,
            name: 'Выполнили задание',
            data: [
                {id: 1, name: 'Да'},
                {id: 0, name: 'Нет'},
            ],
            value: (currentFilters['is_completed'] !== undefined) ? currentFilters['is_completed'] : 0,
            onChange: (val) => {
                console.log('Изменилось: switch ', val);
                currentFilters['is_completed'] = val;
                saveFiltersToStorage(currentType);
                // reset pagination to first page when filters applied
                currentSkip = 0;
                fetchTasks(currentType);
            },
        });

        renderSearch($filtersContainer)

        const $clearFiltersButton = document.createElement('div');
        $clearFiltersButton.style.marginLeft = 'auto';
        $clearFiltersButton.classList.add('filter__header');
        $clearFiltersButton.textContent = 'Сбросить все';
        $clearFiltersButton.style.cursor = 'pointer';
        $clearFiltersButton.addEventListener('click', () => {
            // 1) Очистить фильтры в памяти
            currentFilters = {};

            // 2) Удалить сохранённые фильтры для текущего типа из localStorage
            try {
                const key = storageKeyForType(currentType);
                localStorage.removeItem(key);
            } catch (e) {
                console.warn('Could not remove filters from localStorage', e);
            }

            // 3) Сброс пагинации и перезагрузка фильтров/таблицы
            currentSkip = 0;

            // перерисовать фильтры (fetchFilters -> renderFilters)
            fetchFilters(currentType);

            // обновить список задач (без фильтров)
            fetchTasks(currentType);
        });
        $filtersContainer.appendChild($clearFiltersButton);
    }

    function renderSearch($searchContainer){
        // --- search element (replace previous $filterSearch block with this) ---
        const $filterSearch = $templateFilterSearch.content.cloneNode(true);
        const $filterSearchContainer = $filterSearch.querySelector(`[${DATA_ATTR}-search]`);
        const $filterSearchInput = $filterSearch.querySelector(`[${DATA_ATTR}-search-input]`);

// state classes
        const STATE_COLL = 'is-collapsed';
        const STATE_EXP = 'is-expanded';

// helper: expand / collapse
        const expandSearch = () => {
            $filterSearchContainer.classList.remove(STATE_COLL);
            $filterSearchContainer.classList.add(STATE_EXP);
            // tiny delay to ensure CSS transition before focus
            setTimeout(() => $filterSearchInput.focus(), 0);
        };
        const collapseSearch = () => {
            // only collapse if empty
            if (!$filterSearchInput.value || !$filterSearchInput.value.trim()) {
                $filterSearchContainer.classList.remove(STATE_EXP);
                $filterSearchContainer.classList.add(STATE_COLL);
                // remove saved empty search from filters if any
                if (currentFilters['search']) {
                    delete currentFilters['search'];
                    try { saveFiltersToStorage(currentType); } catch(e){/*ignore*/ }
                    currentSkip = 0;
                    fetchTasks(currentType);
                }
            }
        };

// initialize state: if есть сохранённый поиск — показать развёрнутым и подставить текст
        if (currentFilters['search'] && String(currentFilters['search']).trim()) {
            $filterSearchInput.value = currentFilters['search'];
            $filterSearchContainer.classList.add(STATE_EXP);
        } else {
            $filterSearchContainer.classList.add(STATE_COLL);
            $filterSearchInput.value = '';
        }

// click on container or icon should expand + focus
        $filterSearchContainer.addEventListener('click', (e) => {
            // if currently collapsed -> expand and focus
            if (!$filterSearchContainer.classList.contains(STATE_EXP)) {
                expandSearch();
            } else {
                // if already expanded and user clicked container (not input) — focus input
                $filterSearchInput.focus();
            }
            // prevent global document click handler from immediately closing
            e.stopPropagation();
        });

// input: live search
        $filterSearchInput.addEventListener('input', () => {
            const v = $filterSearchInput.value;
            if (v && v.trim()) {
                currentFilters['search'] = v;
            } else {
                // keep empty value in input but remove filter entry (so empty = "no filter")
                delete currentFilters['search'];
            }
            try { saveFiltersToStorage(currentType); } catch(e){/*ignore*/ }
            currentSkip = 0;
            fetchTasks(currentType);
        });

// blur: collapse only if empty
        $filterSearchInput.addEventListener('blur', () => {
            // use small timeout to allow clicks on container/icon before collapsing
            setTimeout(() => {
                if (!document.activeElement || document.activeElement !== $filterSearchInput) {
                    collapseSearch();
                }
            }, 100);
        });

// close on click outside (but don't duplicate handlers if rerendered)
        if ($filterSearchContainer._outsideHandler) {
            document.removeEventListener('click', $filterSearchContainer._outsideHandler);
        }
        const outsideHandler = (ev) => {
            if (!$filterSearchContainer.contains(ev.target)) {
                // if input empty and not focused -> collapse
                if (document.activeElement !== $filterSearchInput && (!$filterSearchInput.value || !$filterSearchInput.value.trim())) {
                    collapseSearch();
                }
            }
        };
        document.addEventListener('click', outsideHandler);
        $filterSearchContainer._outsideHandler = outsideHandler;

// keyboard: Esc should clear & collapse when empty, or just clear if not empty
        $filterSearchInput.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if ($filterSearchInput.value && $filterSearchInput.value.trim()) {
                    $filterSearchInput.value = '';
                    delete currentFilters['search'];
                    try { saveFiltersToStorage(currentType); } catch(e){/*ignore*/ }
                    currentSkip = 0;
                    fetchTasks(currentType);
                    // keep focus so user can type again if wants
                    $filterSearchInput.focus();
                } else {
                    // empty -> collapse
                    collapseSearch();
                    $filterSearchInput.blur();
                }
            }
        });

        $searchContainer.appendChild($filterSearchContainer);
    }


    function renderTable(data, type) {
        $contentContainer.innerHTML = '';
        if (type === 'case') {
            $tableFragment = $templateTableCase.content.cloneNode(true);
            const $tableContainer = $tableFragment.querySelector(`[${DATA_ATTR}-table-body]`);
            data.forEach(caseData => {
                renderCase(caseData, $tableContainer);
            });
        } else {
            $tableFragment = $templateTableTroika.content.cloneNode(true);
            // If troika rows template exists, you can iterate and render similarly.
            // For now we just append the table (user can extend).
        }

        $contentContainer.appendChild($tableFragment);
    }

    function renderCase(caseData, $caseContainer) {
        const $caseFragment = $templateTableRowCase.content.cloneNode(true);
        const $studentName = $caseFragment.querySelector(`[${DATA_ATTR}-student-name]`);
        const $taskName = $caseFragment.querySelector(`[${DATA_ATTR}-task-name]`);
        const $taskType = $caseFragment.querySelector(`[${DATA_ATTR}-task-type]`);
        const $taskOption = $caseFragment.querySelector(`[${DATA_ATTR}-task-option]`);
        const $taskRate = $caseFragment.querySelector(`[${DATA_ATTR}-task-rate]`);
        const $taskProgresses = $caseFragment.querySelectorAll(`[${DATA_ATTR}-task-progress]`);
        const $taskDownload = $caseFragment.querySelector(`[${DATA_ATTR}-task-download]`);
        const $taskDownloadContainer = $caseFragment.querySelector(`[${DATA_ATTR}-task-download-container]`);


        $studentName.textContent = caseData.student_name;
        $taskName.textContent = caseData.university_group_task;
        $taskType.textContent = caseData.video_title;
        $taskOption.textContent = caseData.exercise_name;
        $taskRate.textContent = caseData.result;

        $taskProgresses.forEach($taskProgress => {
            $taskProgress.textContent = caseData.status;
            $taskProgress.classList.remove('not_started', 'in_progress', 'completed');
            const status_class = caseData.status_meta || 'not_started';
            $taskProgress.classList.add(status_class);
        });
        $taskDownload.innerHTML = $taskDownload.innerHTML;
        $taskDownload.replaceWith($taskDownload.cloneNode(true)); // remove previous listeners
        const $freshDownload = $caseFragment.querySelector(`[${DATA_ATTR}-task-download]`);

        switch (caseData.status_meta) {
            case 'not_started':
            case null:
                $freshDownload.innerHTML = '';
                $taskDownloadContainer.style.display = 'none';
                break;
            case 'in_progress':
                $freshDownload.innerHTML = '';
                $taskDownloadContainer.style.display = 'none';
                break;
            case 'completed':
                $freshDownload.addEventListener('click', () => {
                    const exerciseId = caseData.exercise_id
                    if (!exerciseId) return console.error('No exercise id');
                    const url = `/exercise/${encodeURIComponent(exerciseId)}/summary.pdf?user_id=${caseData.student_id}`;
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank'; // откроет в новой вкладке
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                })
                break;
            default:
                break;
        }

        $caseContainer.appendChild($caseFragment);
    }

    // ---------- Pagination UI ----------
    function renderPagination(total) {
        if (!$pagination || !$paginationContainer) return;

        // compute pages
        const pagesCount = Math.max(1, Math.ceil((total || 0) / currentTake));
        const currentPage = Math.floor(currentSkip / currentTake) + 1;

        // clear container
        $paginationContainer.innerHTML = '';

        const pages = buildVisiblePages(currentPage, pagesCount);

        pages.forEach(item => {
            if (item === '...') {
                const $dot = document.createElement('div');
                $dot.className = `${CLASS_PREFIX}__pagination-item ${CLASS_PREFIX}__pagination-item--dots`;
                $dot.textContent = '...';
                $paginationContainer.appendChild($dot);
            } else {
                const $page = document.createElement('div');
                $page.className = `${CLASS_PREFIX}__pagination-item`;
                if (item === currentPage) $page.classList.add(`${CLASS_PREFIX}__pagination-item--active`);
                $page.setAttribute('data-pagination-page', String(item));
                $page.textContent = String(item);
                $page.addEventListener('click', () => {
                    if (item === currentPage) return;
                    currentSkip = (item - 1) * currentTake;
                    fetchTasks(currentType);
                    // after fetch, renderPagination will be called again
                });
                $paginationContainer.appendChild($page);
            }
        });

        // prev/next state
        if ($paginationPrev) {
            if (currentPage <= 1) {
                $paginationPrev.classList.add('disabled');
            } else {
                $paginationPrev.classList.remove('disabled');
            }
            $paginationPrev.onclick = () => {
                if (currentPage <= 1) return;
                currentSkip = Math.max(0, currentSkip - currentTake);
                fetchTasks(currentType);
            }
        }
        if ($paginationNext) {
            if (currentPage >= pagesCount) {
                $paginationNext.classList.add('disabled');
            } else {
                $paginationNext.classList.remove('disabled');
            }
            $paginationNext.onclick = () => {
                if (currentPage >= pagesCount) return;
                currentSkip = currentSkip + currentTake;
                fetchTasks(currentType);
            }
        }
    }

    // helper: build visible pages array with ellipsis
    // returns array like [1, '...', 4,5,6, '...', 20]
    function buildVisiblePages(current, total) {
        const delta = 2; // pages around current
        const range = [];
        const pages = [];

        for (let i = Math.max(1, current - delta); i <= Math.min(total, current + delta); i++) {
            range.push(i);
        }

        if (1 < range[0]) {
            pages.push(1);
            if (2 < range[0]) {
                pages.push('...');
            } else if (2 === range[0]) {
                pages.push(2);
            }
        }

        pages.push(...range);

        if (range[range.length - 1] < total) {
            if (range[range.length - 1] + 1 < total) {
                pages.push('...');
            } else if (range[range.length - 1] + 1 === total) {
                pages.push(total - 1);
            }
            pages.push(total);
        }

        // If total small, normalize: [1..total]
        if (total <= 7) {
            return Array.from({length: total}, (_, i) => i + 1);
        }

        return pages;
    }

    // ---------- Filter persistence helpers ----------
    function storageKeyForType(type) {
        return `${STORAGE_KEY_PREFIX}-${type}`;
    }

    function saveFiltersToStorage(type) {
        try {
            const key = storageKeyForType(currentType);
            localStorage.setItem(key, JSON.stringify(currentFilters || {}));
        } catch (e) {
            // ignore storage errors
            console.warn('Could not save filters to localStorage', e);
        }
    }

    function loadFiltersFromStorage(type) {
        try {
            const key = storageKeyForType(currentType);
            const raw = localStorage.getItem(key);
            if (!raw) {
                currentFilters = {};
                return {};
            }
            const parsed = JSON.parse(raw);
            currentFilters = parsed && typeof parsed === 'object' ? parsed : {};
            return currentFilters;
        } catch (e) {
            console.warn('Could not load filters from localStorage', e);
            currentFilters = {};
            return {};
        }
    }

}
